export const resolveVariantNavigation = (link) => {
  if (!link?.variantId || !link?.productId) return null;

  if (link.type === 'masterVariant') {
    return {
      masterProductId: link.productId,
      masterVariantId: link.variantId,
    };
  }

  if (link.masterProductId && link.masterVariantId) {
    return {
      masterProductId: link.masterProductId,
      masterVariantId: link.masterVariantId,
    };
  }

  return null;
};

export const resolveProductNavigation = (productLink) => {
  if (!productLink?._id) return null;

  if (productLink.type === 'master' || (!productLink.type && !productLink.masterProductId)) {
    return { masterProductId: productLink._id };
  }

  if (productLink.masterProductId) {
    return { masterProductId: productLink.masterProductId };
  }

  return null;
};
